import { render, staticRenderFns } from "./catalogInfo.vue?vue&type=template&id=7891fae4&scoped=true&"
import script from "./catalogInfo.vue?vue&type=script&lang=js&"
export * from "./catalogInfo.vue?vue&type=script&lang=js&"
import style0 from "./catalogInfo.vue?vue&type=style&index=0&id=7891fae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7891fae4",
  null
  
)

export default component.exports